import { create } from "zustand";
import { toastError } from "../../Helpers/toasts";
import MainGroupsRepository from "../../Repositories/Groups/MainGroupsRepository";
import StudentEarnedCardsRepository from "../../Repositories/Reports/StudentEarnedCardsRepository";

export const useStudentEarnedCardStore = create((set) => ({
  results: null,
  reasoning: null,
  absences_count: null,
  startDate: null,
  endDate: null,
  pagination: null,
  branches: null,
  isLoading: false,
  queryParams: {
    page: 1,
  },

  setLoading: (status) => {
    set({
      isLoading: status,
    });
  },

  updateParams: (paramItem) => {
    set((prevState) => ({
      queryParams: { ...prevState.queryParams, ...paramItem },
    }));
  },

  getBranches: async () => {
    const { data, status } = await MainGroupsRepository.getAllBranches()
    if (status) {
      set({
        branches: data,
      })
    }
  },
  onReload: async (queryString = "") => {
    const { data, status, nonFieldErrors } =
      await StudentEarnedCardsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.results.students,
        absences_count: data.results.students_count,
        reasoning: data.results.filterset.cards,
        pagination: { page_count: data.pages_count || 1 },
        queryParams: { page: 1 },
      });
    } else toastError(nonFieldErrors);
  },

  loadItems: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await StudentEarnedCardsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.results.students,
        absences_count: data.results.students_count,
        pagination: { page_count: data.pages_count || 1 },
      });
    } else toastError(nonFieldErrors);
  },
}));
